import gql from 'graphql-tag';

import { FULL_COMMENT_FRAGMENT } from '../fragments/Comment/fullComment';

export const GET_COMMENTS_SUBSCRIPTION = gql`
  subscription GetCommentsSubscription($id: String!, $isPost: Boolean!) {
    comment(id: $id, isPost: $isPost) {
      ...fullComment
    }
  }
  ${FULL_COMMENT_FRAGMENT}
`;
